export const isCorsError = ({ name, message }: Error) =>
  name === 'SecurityError' || message === 'Permission denied'
